import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useAppSelector } from '@redux/hooks';
import { Button, ButtonSize, ButtonThemes, LinkTheme, MyLink } from '@app/shared';
import { GridLinksTypeProps } from './TypeProps';
import classNames from 'classnames';
import IconArrow from './icons/Arrow.svg';

import styles from './GridLinks.module.scss';

const HEIGHT = 95;

export const GridLinks: FC<GridLinksTypeProps> = ({ className, links, showAll }) => {
  const host = useAppSelector(state => state.header.data.host);
  const [hide, setHide] = useState<boolean>(false);
  const [overflow, setOverflow] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>();
  const handleShowAll = useCallback(() => {
    setHide(prevState => !prevState);
  }, []);
  useEffect(() => {
    if (!hide && containerRef.current?.clientHeight > HEIGHT) {
      setHide(true);
      setOverflow(true);
    }
  }, []);

  return (
    <div ref={containerRef} className={classNames(styles.WrapperGridLinks, { [styles.hide]: hide && !showAll }, className)}>
      <div className={styles.Container}>
        {links.map(link => (
          <MyLink reloaded themes={LinkTheme.Theme8} key={link.title} href={host + link.href}>
            {link.title}
          </MyLink>
        ))}
      </div>
      {!showAll && overflow && (
        <Button size={ButtonSize.S} themes={ButtonThemes.BlackSecondary} onClick={handleShowAll}>
          {hide ? 'Показать еще' : 'Скрыть'} <IconArrow width={11} height={14} />
        </Button>
      )}
    </div>
  );
};
